import { countries, currencies } from "country-data-list";

const countryByCode = countries as unknown as Record<
  string,
  { currencies?: string[] } | undefined
>;
const currencyByCode = currencies as unknown as Record<
  string,
  { symbol?: string; code?: string } | undefined
>;

export interface RateCurrency {
  symbol: string;
  code: string;
}

const USD: RateCurrency = { symbol: "$", code: "USD" };

/**
 * The rate is stored in USD, so every surface that renders one has to agree on
 * which currency it is showing. Both the settings form and the /join rate step
 * resolve it here so they cannot display different symbols for the same number.
 */
export function getCurrencyForCountry(
  countryCode: string | null | undefined,
): RateCurrency {
  if (!countryCode) {
    return USD;
  }
  const currencyCode =
    countryByCode[countryCode.toUpperCase()]?.currencies?.[0];
  if (!currencyCode) {
    return USD;
  }
  const currency = currencyByCode[currencyCode];
  return {
    symbol: currency?.symbol || USD.symbol,
    code: currency?.code || USD.code,
  };
}

/** The money shape a rate input accepts mid-typing, so "12." stays editable. */
export const RATE_INPUT_PATTERN = /^\d*\.?\d{0,2}$/;

export function formatRateInput(value: string): string {
  if (value === "") {
    return "";
  }
  const num = Number(value);
  if (Number.isNaN(num)) {
    return value;
  }
  return num.toFixed(2);
}

export function parseRateInput(value: string): number | null {
  if (value.trim() === "") {
    return null;
  }
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}
